<div class="filter-component">
  <div class="container-filter-main">
    <span class="filter__title">Mostrar seguradoras</span>
    <div class="search-filter-seguradoras">
      <input
        class="search-filter__input"
        type="text"
        style="width: 200px;"
        placeholder="Pesquisar por Seguradora"
        (input)="onBuscaChange($event)"
      />
      <mat-icon class="search-filter__icon" svgIcon="magnify"></mat-icon>
    </div>
    <div class="item-filter">
      <ul class="lista">
        <li class="item clickable-item" (click)="toggleAllSeguradoras(!checkedAll)">
          <mat-checkbox
            [checked]="checkedAll"
            color="primary"
            labelPosition="before"
            [disabled]="false"
          >
            <div class="filter__group-icon">
              <div class="filter__name">Todas</div>
            </div>
          </mat-checkbox>
        </li>
        
        @for (seguradora of seguradorasFilteredList; track $index) {
        <li class="item clickable-item" (click)="changeCheckSeguradora(!seguradora.checked, seguradora)">
          <mat-checkbox
            [checked]="seguradora.checked"
            color="primary"
            labelPosition="before"
            [disabled]="false"
          >
            <div class="filter__group-icon">
              @if (seguradora.logo) {
              <img [src]="seguradora.logo" />
              }
              <div class="filter__name">{{ seguradora.nome }}</div>
            </div>
          </mat-checkbox>
        </li>
        } @empty {
        <span>Nenhuma seguradora encontrada.</span>
        }
      </ul>
    </div>
  </div>
</div>
